module.exports = __webpack_public_path__ + "img/gbwhatsappBg.a18d7dd7.webp";